const root = document.getElementById('afs');
if (root) {
  // Shopify caches unversioned asset URLs for a year. Liquid supplies the
  // current versions of these shared modules, including dependency-only edits.
  const [{ curateCatalog, mergeCatalogs }, { BANNER_FORMATS, validateBannerFile }] = await Promise.all([
    import(root.dataset.catalogModule), import(root.dataset.bannersModule)
  ]);
  const $ = id => root.querySelector('#afs-' + id), form = $('form'), select = $('room'), taken = $('taken');
  const variants = JSON.parse($('variants').textContent), submit = form.querySelector('[type=submit]');
  const service = $('service')?.dataset.url || '', termKeys = { 'One Month': 'month', 'One Year': 'year', 'Lifetime naming': 'lifetime' };
  let serviceRooms = {}, serviceEnabled = false, submitting = false, requestId = '';
  const SIZE = { cabinet: 'Cabinet', gallery: 'Gallery', grand: 'Grand Gallery' };
  const money = c => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: root.dataset.currency || 'USD', maximumFractionDigits: 0 }).format(c / 100);
  let rooms = [], sponsors = {}, available = false, validating = false, checkedFile = null, previewURL = '', attempt = 0;
  const file = $('banner'), placement = $('placement'), message = $('banner-status');
  function bannerUI() {
    const spec = BANNER_FORMATS[placement.value], enabled = !!spec;
    $('banner-fields').hidden = !enabled; file.disabled = !enabled; file.required = enabled;
    $('banner-help').textContent = spec ? `${spec.width} × ${spec.height} pixels exactly · JPG or PNG · up to 5 MB. Keep text and logos 5% away from the edges. Use a solid background for predictable contrast.` : '';
    $('banner-consent').required = enabled; $('banner-consent').disabled = !enabled;
    $('banner-preview').hidden = !enabled || !checkedFile;
    $('banner-preview').dataset.placement = placement.value;
    $('preview-name').textContent = $('name').value.trim() || 'Your sponsorship name';
    $('name').setCustomValidity($('name').value.trim() ? '' : 'Enter the name to display in your room.');
    submit.disabled = !available || validating || submitting;
  }
  async function checkFile() {
    const id = ++attempt; checkedFile = null; validating = true;
    if (previewURL) URL.revokeObjectURL(previewURL); previewURL = '';
    message.textContent = 'Checking your artwork…'; file.setCustomValidity('Please wait while the artwork is checked.'); bannerUI();
    try {
      const chosen = file.files[0];
      await validateBannerFile(chosen, placement.value);
      if (id !== attempt) return;
      checkedFile = chosen; previewURL = URL.createObjectURL(chosen);
      $('preview-image').src = previewURL; file.setCustomValidity(''); message.textContent = 'Artwork ready. Your image will be displayed in full, without cropping.';
    } catch (e) {
      if (id !== attempt) return;
      file.setCustomValidity(e.message); message.textContent = e.message;
    } finally { if (id === attempt) { validating = false; bannerUI(); } }
  }
  placement.addEventListener('change', () => {
    attempt++; validating = false; checkedFile = null; file.value = ''; file.setCustomValidity(''); message.textContent = '';
    if (previewURL) URL.revokeObjectURL(previewURL); previewURL = ''; $('preview-image').removeAttribute('src');
    bannerUI();
  });
  file.addEventListener('change', checkFile);
  $('name').addEventListener('input', bannerUI);
  function sync() {
    const r = rooms.find(x => x.key === select.value);
    $('room-key').value = r?.key || ''; $('room-name').value = r?.name || '';
    const size = SIZE[r?.tier] || 'Gallery', term = form.querySelector('input[name=afs-term]:checked')?.value;
    form.querySelectorAll('[data-price-for]').forEach(el => {
      const v = variants.find(x => x.option1 === el.dataset.priceFor && x.option2 === size);
      const amount = service && r ? serviceRooms[r.key]?.prices[termKeys[el.dataset.priceFor]] : null;
      el.textContent = amount ? new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:'USD',maximumFractionDigits:0}).format(Number(amount)) : v ? money(v.price) + (r ? '' : ' · Gallery size') : 'Unavailable';
    });
    const v = variants.find(x => x.option1 === term && x.option2 === size);
    const sponsor = r && sponsors[r.key];
    available = service ? !!r && serviceEnabled && !!serviceRooms[r.key]?.available && !sponsor : !!r && !!v?.available && !sponsor;
    $('variant').value = available && v ? v.id : '';
    taken.textContent = sponsor ? `Currently sponsored by ${sponsor.name}. Please choose another room.` : service && !serviceEnabled ? 'Sponsorship checkout is being prepared. Please check back soon.' : r && !available ? 'This room is currently reserved or unavailable. Please choose another.' : '';
    bannerUI();
  }
  form.addEventListener('submit', async e => {
    if (service) e.preventDefault();
    const enabled = !!BANNER_FORMATS[placement.value];
    if (!available || validating || enabled && checkedFile !== file.files[0]) {
      e.preventDefault();
      if (!available) { select.focus(); taken.textContent ||= 'Choose an available room and term.'; }
      else { file.reportValidity(); message.textContent ||= 'Choose and check your banner before continuing.'; }
      return;
    }
    if (service) {
      if (submitting) return;
      submitting = true; bannerUI(); $('checkout-status').textContent = 'Reserving your room and opening secure Shopify checkout…';
      try {
        requestId ||= crypto.randomUUID().replaceAll('-', '');
        const data = new FormData();
        data.set('request_id', requestId); data.set('room', select.value); data.set('name', $('name').value.trim());
        data.set('term', termKeys[form.querySelector('input[name=afs-term]:checked').value]); data.set('placement', placement.value);
        if (enabled) { data.set('banner', file.files[0]); data.set('permission', $('banner-consent').checked ? 'yes' : 'no'); }
        const response = await fetch(service + '/api/checkout', { method:'POST', body:data });
        const result = await response.json();
        if (!response.ok) throw new Error(result.detail || 'Checkout could not be opened. Please try again.');
        const checkout = new URL(result.checkout_url);
        if (checkout.protocol !== 'https:' || !['artfunk.org','art-alex-funk.myshopify.com','checkout.shopify.com'].includes(checkout.hostname)) throw new Error('Checkout could not be verified. Please contact Alex.');
        location.assign(checkout.href);
      } catch (error) { $('checkout-status').textContent = error.message; submitting = false; bannerUI(); }
    }
    // Leave a validated multipart form to Shopify: the actual File, placement,
    // room key and display name remain properties on the same cart line.
  });
  select.addEventListener('change', sync);
  form.addEventListener('input', () => { if (!submitting) requestId = ''; });
  $('terms').addEventListener('change', () => { form.querySelectorAll('.afs-term').forEach(l => l.classList.toggle('on', l.querySelector('input').checked)); sync(); });
  bannerUI();
  try {
    const read = async url => { const r = await fetch(url, { cache: 'no-cache' }); if (!r.ok) throw new Error('Could not load room availability. Please reload this page.'); return r.json(); };
    const [art, photos, additions, curation, paid] = await Promise.all(['rooms', 'photos', 'additions', 'curation', 'sponsors'].map(key => read(root.dataset[key])));
    if (service) { const live = await read(service + '/api/rooms'); serviceEnabled = live.enabled; serviceRooms = Object.fromEntries(live.rooms.map(r => [r.key,r])); }
    const catalog = curateCatalog(mergeCatalogs(art, photos, additions), curation);
    rooms = catalog.rooms.filter(r => catalog.works.some(w => !w.featured && w.series === r.key));
    sponsors = Object.fromEntries(Object.entries(paid.rooms || {}).filter(([, s]) => !s.until || new Date(s.until).getTime() > Date.now()));
    if (service) sponsors = Object.fromEntries(Object.entries(serviceRooms).filter(([,r]) => r.sponsor).map(([key,r]) => [key,{name:r.sponsor}]));
    // Manually lettered rooms also count as occupied.
    for (const r of rooms) if (r.sponsorName && (!r.sponsorUntil || new Date(r.sponsorUntil + 'T23:59:59Z').getTime() > Date.now())) sponsors[r.key] ||= { name: r.sponsorName };
    select.replaceChildren(new Option('Choose a room', ''));
    for (const r of rooms) { const unavailable = sponsors[r.key] || service && !serviceRooms[r.key]?.available; const option = new Option(r.name + (r.floor === 2 ? ' · upstairs' : '') + (unavailable ? ' · unavailable' : ''), r.key); option.disabled = !!unavailable; select.add(option); }
    const room = new URLSearchParams(location.search).get('room'); if (rooms.some(r => r.key === room)) select.value = room;
    sync();
  } catch (e) { select.replaceChildren(new Option('Rooms unavailable — reload to try again', '')); taken.textContent = e.message; }
}
